import { useEffect, useState } from 'react'

import { useFetchReleasesQuery } from '../queries/fetch-reseases.query'
import { useVersionStore } from '../stores/version-store'
import type { Release } from '../types/release.type'

export function useReleaseNote() {
  const [releases, setReleases] = useState<Release[]>([])

  const { data, isSuccess, isLoading, refetch } = useFetchReleasesQuery()

  const {
    actions: { setHasNewVersion, setLastVersion },
  } = useVersionStore()

  useEffect(() => {
    if (isSuccess) {
      setReleases(data.releases)
    }
  }, [isLoading])

  useEffect(() => {
    if (!releases.length) {
      return
    }

    setLastVersion(releases[0]?.code)
    setHasNewVersion(false)
  }, [releases])

  return {
    handleFetchReleases: refetch,
    releases,
  }
}
